// extracted by mini-css-extract-plugin
module.exports = {"container":"search_container__nb1Jc","btn":"search_btn__oqZUF"};